import React from 'react'
import './styles.scss';
import { isMobile } from '../../../helpers/Mobile';
import { useHistory } from 'react-router-dom';
import useRequest from '../../../hooks/useRequest';
import { useStore, useStorePersist } from "store/context";

import { AuthService } from '../../../services/AuthService';
import Icon from "../Icon";
import { Link } from 'react-router-dom';

import logooscuro from 'assets/images/logo-oscuro.png';

const BaseHeader =  ({username}) => {
    const history = useHistory();

    const {
        submitted, success, message,
        beforeSubmit, afterSubmit, showSuccess, showError,
        dealWithError
    } = useRequest();

    const [{}, dispatch] = useStore();

    const [{}, dispatchPersist] = useStorePersist();

    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch({
            type: 'resetUnidades',
            payload: {},
        });
        dispatchPersist({
            type: 'resetUnidadesPersist',
            payload: {},
        });
        AuthService.logout();
    }

return <div className="base-header-container">
   {!isMobile &&
   <div className="base-header-title">
       <h1 className="base-header-title-text">Oficina Virtual</h1>
   </div>
    }
    {isMobile &&
        <div className="base-header-title">
            <Link to="/home">
                <h1 className="base-header-title-text"><img src={logooscuro} /><br></br>Oficina Virtual</h1>
            </Link>
        </div>
    }
    {
    <div className="base-header-user">
        {/* <div className="base-header-user-info">
                <div className="base-header-user-info-title"><strong>Hola,</strong> <span className="base-header-user-info-title-name">{username}</span></div>
        </div> */}
        <div className="base-header-actions">
            <div className="base-header-actions-notifications">
                <Icon name="bell" width={45} height={30} fill={isMobile ? '#9e9e9e' : '#9e9e9e'} />
                {/* <span className="base-header-actions-notifications-number">8</span> */}
            </div>
            <div className="base-header-actions-logout">
                    <a onClick={handleSubmit}><Icon name="shutdown" width={45} height={30} fill={isMobile ? '#9e9e9e' : '#9e9e9e'} />
                    </a>
            </div>
        </div>
    </div>
    }
</div>
}

export default BaseHeader;